"use client";

import Link from "next/link";
import { ChevronRight } from "lucide-react";

/**
 * Internal linking section for SEO. Renders H2 + list of tool links.
 * @param {Object} props
 * @param {{ href: string, label: string }[]} props.links - Links to related tools
 * @param {string} [props.title="Related tools"] - Section heading
 */
export default function RelatedToolsSection({ links = [], title = "Related tools" }) {
  if (!links?.length) return null;

  return (
    <section className="relative overflow-hidden rounded-3xl border border-cyan-500/20 bg-gradient-to-br from-cyan-500/10 via-slate-900 to-blue-600/5 p-6 sm:p-10 lg:p-14 shadow-2xl" aria-labelledby="related-tools-heading">
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(circle_at_20%_20%,rgba(34,211,238,0.08),transparent_32%)]" />
      <div className="relative space-y-4">
        <h2 id="related-tools-heading" className="text-xl sm:text-2xl font-bold text-white">
          {title}
        </h2>
        <p className="text-sm text-gray-300">
          Use these IDX Solana tools together to launch and manage your token.
        </p>
        <ul className="grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
          {links.map(({ href, label }) => (
            <li key={href}>
              <Link
                href={href}
                className="flex items-center gap-2 rounded-xl border border-gray-700/50 bg-gray-800/50 px-4 py-3 text-sm text-gray-200 hover:border-cyan-500/40 hover:bg-gray-800 hover:text-white transition-colors"
                rel="noopener noreferrer"
              >
                <span className="flex-1">{label}</span>
                <ChevronRight className="h-4 w-4 flex-shrink-0 text-cyan-400" />
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
